import PublicNav from "../components/PublicNav";
import { Logo } from "../components/Logo";

function LegalPage({ title, children }) {
  return (
    <div className="min-h-screen bg-slate-50">
      <PublicNav />
      <main className="mx-auto max-w-3xl px-4 py-14 sm:px-6">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
        <p className="mt-1 text-xs text-slate-400">Last updated: September 2026</p>
        <div className="mt-8 space-y-6 text-sm leading-relaxed text-slate-600">{children}</div>
      </main>
      <footer className="border-t border-slate-200 bg-white py-8">
        <div className="mx-auto flex max-w-3xl items-center justify-between px-4 sm:px-6">
          <Logo height="h-8" />
          <p className="text-xs text-slate-400">© PropLoX. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

function P({ children }) { return <p>{children}</p>; }
function H({ children }) { return <h2 className="text-base font-semibold text-slate-900">{children}</h2>; }

export function Privacy() {
  return (
    <LegalPage title="Privacy Policy">
      <P>PropLoX ("we", "our") operates a property transaction services and workflow platform. This policy explains what information we collect and how we use it.</P>
      <H>Information we collect</H>
      <P>Account details (name, email, phone), property documents you upload for verification, service enquiry details, and transaction/property information you enter while using the platform.</P>
      <H>How we use it</H>
      <P>To provide the requested services: document verification, report generation, transaction tracking, and customer support. Uploaded documents are processed by our document-analysis system to produce verification findings.</P>
      <H>Storage and security</H>
      <P>Documents are stored in encrypted cloud object storage and access is restricted to your account. We do not sell your personal information or documents to third parties.</P>
      <H>Professional review</H>
      <P>Where you request legal review, relevant documents and findings may be shared with the reviewing legal professional solely for that purpose.</P>
      <H>Your choices</H>
      <P>You may request access, correction or deletion of your data by writing to support@proplox.com.</P>
      <H>Contact</H>
      <P>PropLoX, Sharavi Plaza, near Chethana Hotel, Davanagere, Karnataka · +91 73381 96493 · support@proplox.com</P>
    </LegalPage>
  );
}

export function Terms() {
  return (
    <LegalPage title="Terms of Service">
      <P>By using PropLoX you agree to these terms. PropLoX provides property-related services including AI-assisted document verification, document support, registration assistance, loan assistance and coordination of professional legal review.</P>
      <H>Nature of AI-assisted analysis</H>
      <P>AI-assisted document analysis does not replace professional legal judgement or legal advice. Verification findings are based solely on the documents and information made available, and potential inconsistencies are presented for further attention rather than as a final determination of title.</P>
      <H>Your responsibilities</H>
      <P>You are responsible for the accuracy and authenticity of the documents you upload and for verifying original documents with the concerned authorities before making financial or legal decisions.</P>
      <H>Payments</H>
      <P>Paid services (such as report unlocks) are processed through our payment gateway partner. Fees are displayed before payment and are non-refundable once the report has been generated, except where required by law.</P>
      <H>Availability</H>
      <P>We aim for reliable service but do not guarantee uninterrupted availability. Service timelines depend on the documents and information available for each transaction.</P>
      <H>Contact</H>
      <P>PropLoX, Sharavi Plaza, near Chethana Hotel, Davanagere, Karnataka · +91 73381 96493 · support@proplox.com</P>
    </LegalPage>
  );
}
